import { __awaiter } from '../../../../../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useInternalDynamicContext } from '../../../../context/DynamicContext/useInternalDynamicContext.js';
import { useLoadingContext } from '../../../../context/LoadingContext/LoadingContext.js';
import { useWidgetContext } from '../../context/DynamicWidgetContext.js';
import { WidgetPortal } from '../../components/WidgetPortal/WidgetPortal.js';
import 'react';
import { Typography } from '../../../../components/Typography/Typography.js';
import '@dynamic-labs/sdk-api';
import { logger } from '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../../../context/ViewContext/ViewContext.js';
import '../../../../utils/constants/colors.js';
import '../../../../shared/consts/index.js';
import '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../config/ApiEndpoint.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { Button } from '../../../../components/Button/Button.js';
import '../../../../components/IconButton/IconButton.js';

const UnlinkWalletPopUp = ({ walletId }) => {
    const { setWalletIdToUnlink } = useWidgetContext();
    const { handleUnlinkWallet, eventsCallbacks, user } = useInternalDynamicContext();
    const { loading, setLoading } = useLoadingContext();
    const onConfirmClick = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            setLoading(true);
            yield handleUnlinkWallet(walletId);
            setWalletIdToUnlink(undefined);
            const walletFromId = user === null || user === void 0 ? void 0 : user.verifiedCredentials.find((wallet) => wallet.id === walletId);
            if (walletFromId) {
                (_a = eventsCallbacks === null || eventsCallbacks === void 0 ? void 0 : eventsCallbacks.onUnlinkSuccess) === null || _a === void 0 ? void 0 : _a.call(eventsCallbacks, walletFromId);
            }
        }
        catch (error) {
            logger.error(error);
        }
        finally {
            setLoading(false);
        }
    });
    const onCancelClick = () => {
        setWalletIdToUnlink(undefined);
    };
    return (jsx(WidgetPortal, Object.assign({ onBackdropClick: onCancelClick }, { children: jsxs("div", Object.assign({ className: 'unlink-wallet-popup__container' }, { children: [jsx(Typography, Object.assign({ color: 'primary', className: 'unlink-wallet-popup__title', variant: 'body_normal', as: 'h6' }, { children: "Unlink your wallet?" })), jsx(Typography, Object.assign({ className: 'unlink-wallet-popup__label', variant: 'body_small', color: 'secondary' }, { children: "Are you sure you want to unlink your wallet?" })), jsx(Button, Object.assign({ buttonPadding: 'small', onClick: onConfirmClick, disabled: loading, buttonClassName: 'unlink-wallet-popup__button unlink-wallet-popup__button--shadow', color: 'primary', expanded: true, buttonRounded: 'small', typographyProps: {
                        variant: 'button_secondary',
                        weight: 'medium',
                    }, dataTestId: 'unlink-wallet-popup-yes-button' }, { children: "Yes, unlink" })), jsx(Button, Object.assign({ expanded: true, buttonPadding: 'small', onClick: onCancelClick, buttonVariant: 'secondary', buttonClassName: 'unlink-wallet-popup__button', buttonRounded: 'small', typographyProps: {
                        variant: 'button_secondary',
                        weight: 'medium',
                    } }, { children: "No" }))] })) })));
};

export { UnlinkWalletPopUp };
